import React from 'react';

import {
  FormControlLabel,
  FormControl,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Badge
} from '@material-ui/core';
import moment from 'moment';
import EditIcon from '@material-ui/icons/Edit';
import { navigate } from '@reach/router';

import { IUserStore } from '../../../../store/user/store';

import { userPic } from '../../../../assets/images';
import Button from '../../../../components/Button';
import DatePicker from '../../../../components/DatePicker';
import { FormConsumer, FormProvider, IFormAttributes } from '../../../../components/Forms';
import Input from '../../../../components/Input';

interface IProps {
  user: IUserStore;
  onSubmit: ({ user }: { user: IUserStore }) => Promise<any>;
}

const goToPicture = () => {
  if (location.pathname === `/staff/profile/settings`) {
    navigate('/staff/profile/select-picture');
  } else {
    navigate('/profile/select-picture');
  }
};

const UserInfo = ({ user, onSubmit }: IProps) => (
  <div className="user-info wrapper form">
    <Paper elevation={1} className="paper">
      <div className="avatar-wrapper">
        <Badge
          badgeContent={<EditIcon />}
          color="primary"
          className="avatar-badge"
          onClick={goToPicture}
        >
          <img
            id="edit-picture"
            src={user.profile.image ? user.profile.image : userPic}
            alt={user.firstName + ' avatar'}
          />
        </Badge>
      </div>

      {user.email && (
        <FormProvider
          defaultValues={{ user }}
          onSubmit={onSubmit}
          validations={{
            'user.email': 'required',
            'user.firstName': 'required',
            'user.lastName': 'required',
            'user.profile.birthDate': 'required'
          }}
        >
          <FormConsumer>
            {({ values, formActions: { setValue }, errors }: IFormAttributes) => (
              <div className="form">
                <Input
                  label="FIRST NAME"
                  id="first-name"
                  type="text"
                  value={values.user.firstName}
                  onChange={setValue('user.firstName')}
                  hasError={errors['user.firstName']}
                  errorMessage="First Name cannot be empty"
                  fullWidth={true}
                />

                <Input
                  label="LAST NAME"
                  id="last-name"
                  type="text"
                  value={values.user.lastName}
                  onChange={setValue('user.lastName')}
                  hasError={errors['user.lastName']}
                  errorMessage="Last Name cannot be empty"
                  fullWidth={true}
                />

                <Input
                  label="EMAIL"
                  id="email"
                  type="email"
                  value={values.user.email}
                  disabled={true}
                  onChange={setValue('user.email')}
                  hasError={errors['user.email']}
                  errorMessage={'You must provide a valid email'}
                  fullWidth={true}
                />

                <Input
                  label="GHIN NUMBER"
                  id="ghin-number"
                  type="text"
                  value={values.user.profile.ghinNumber}
                  onChange={setValue('user.profile.ghinNumber')}
                  hasError={errors['user.profile.ghinNumber']}
                  fullWidth={true}
                />

                <FormControl className="gender-form-control">
                  <FormLabel>GENDER</FormLabel>
                  <RadioGroup
                    aria-label="Gender"
                    name="gender"
                    id="gender"
                    value={values.user.profile.gender}
                    onChange={setValue('user.profile.gender')}
                    className={'radio-group'}
                  >
                    <FormControlLabel
                      className="option"
                      value="M"
                      control={<Radio />}
                      label="Male"
                    />
                    <FormControlLabel
                      className="option"
                      value="F"
                      control={<Radio />}
                      label="Female"
                    />
                  </RadioGroup>
                </FormControl>

                <div className="extra-label">BIRTHDATE</div>
                <DatePicker
                  id="birthdate"
                  label=""
                  placeholder="10/10/2018"
                  value={values.user.profile.birthDate}
                  onChange={setValue('user.profile.birthDate')}
                  onError={setValue('user.profile.birthDate')}
                  maxDate={moment()
                    .add(-5, 'years')
                    .format('YYYY-MM-DD')}
                />

                <Button
                  variant="contained"
                  color="primary"
                  disabled={errors.FORM}
                  type="submit"
                  className="button button-shadow submit"
                >
                  SAVE
                </Button>
              </div>
            )}
          </FormConsumer>
        </FormProvider>
      )}
    </Paper>
  </div>
);

export { UserInfo };
